// 购物车按钮事件处理核心函数
function handleAddToCartClick(e) {
  e.preventDefault();
  let button = $(this);
  
  // 保存原始HTML（包含SVG等标记）
  const originalHTML = button.data('original-html') || button.html();
  if (!button.data('original-html')) {
    button.data('original-html', originalHTML);
  }
  
  // 按钮状态切换（使用HTML内容）
  button.html('<span class="spinner">Adding....</span>')
    .attr('disabled', true)
    .addClass('btn-loading');
  
  // 发送添加到购物车请求
  const variantID = button.data('product-variant');
  const quantity = 1;
  
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: { quantity, id: variantID },
    dataType: 'json',
    success: function(response) {
      // 更新购物车数量
      fetch(window.Shopify.routes.root + 'cart.js')
        .then(res => res.json())
        .then(cartData => {
          $('.hdt-site-nav_cart .hdt-count-box').text(cartData.item_count);
          setTimeout(() => {
        $("hdt-cart-drawer").load(location.href + " hdt-cart-drawer", function(responseText, status, xhr) {
        });
      }, 500);
        });
      
      // 成功状态（显示带图标的"Added!"）
      button.html('Added!')
        .removeClass('btn-loading');
      
      // 延迟恢复原始HTML
      setTimeout(() => {
        button.html(button.data('original-html'))
          .removeAttr('disabled')
          .removeClass('btn-loading');
      }, 2000);
    },
    error: function() {
      // 错误状态（显示带图标的"Error"）
      button.html('Error: Sold Out')
        .removeClass('btn-loading');
      
      setTimeout(() => {
        button.html(button.data('original-html'))
          .removeAttr('disabled')
          .removeClass('btn-loading');
      }, 2000);
    }
  });
}

// 页面加载时初始化
jQuery(document).ready(function($) {
  // 事件委托绑定
  $(document).on('click', '.sv-collection-add-to-cart-btn', handleAddToCartClick);
  observeDOMChanges();
   
});

// 监听DOM变化
function observeDOMChanges() {
  const config = { attributes: true, childList: true, subtree: true };
  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      if (mutation.type === 'childList') {
        bindButtonsOnDOMChange();
      }
    });
  });
  if (document.body) {
    observer.observe(document.body, config);
    // console.log('DOM变化监听已启动');
  }
}

// DOM变化时绑定事件
function bindButtonsOnDOMChange() {
  setTimeout(() => {
    const newButtons = $('.sv-collection-add-to-cart-btn:not(.btn-bound)');
    if (newButtons.length > 0) {
      newButtons.addClass('btn-bound');
      newButtons.on('click', handleAddToCartClick);
      // console.log(`发现${newButtons.length}个新按钮，已绑定事件`);
    }
  }, 300);
}

// 手动绑定函数
window.forceBindAddToCart = function() {
  $(document).off('click', '.sv-collection-add-to-cart-btn');
  $(document).on('click', '.sv-collection-add-to-cart-btn', handleAddToCartClick);
  // console.log('手动强制绑定添加到购物车事件');
};



// sv collection filter
(function($) {
  // 筛选器初始化
  function initCollectionFilter() {
    const currentUrl = window.location.href;
    
    // 处理型号筛选
    handleModelFilter(currentUrl);
    
    // 处理类型筛选
    handleTypeFilter(currentUrl);
    
    // 型号选择变化事件
    $('#sv_filter_size').on('change', function() {
      const selectedModel = $(this).val();
      if (selectedModel) {
        updateUrlWithModel(selectedModel);
      }
    });
    
    // 类型点击事件
    $('.sv_coll_filter_type a').on('click', function(e) {
      e.preventDefault();
      const caseType = $(this).text().trim();
      
      // 移除所有选中状态
      $('.sv_current_type').removeClass('sv_current_type');
      
      // 添加选中状态到当前项
      $(this).closest('li').addClass('sv_current_type');
      
      // 更新URL
      updateUrlWithCaseType(caseType);
    });
  }
  
  // 处理型号筛选逻辑
  function handleModelFilter(url) {
    const modelRegex = /collections\/(iphone-\d{1,2}(?:-pro)?(?:-plus)?(?:-max)?(?:-air)?-cases|all-iphone-cases)/;
    const match = url.match(modelRegex);
    
    if (match && match[1]) {
      $(`#sv_filter_size option[value="${match[1]}"]`).prop('selected', true);
    }
  }
  
  // 处理类型筛选逻辑
  function handleTypeFilter(url) {
    const typeRegex = /filter\.v\.option\.case\+type=([^&]+)/;
    const match = url.match(typeRegex);
    
    // 移除所有选中状态
    $('.sv_current_type').removeClass('sv_current_type');
    
    if (match && match[1]) {
      const currentType = decodeURIComponent(match[1].replace(/\+/g, ' '));
      
      // 高亮匹配的类型
      $('.sv_coll_filter_type a').each(function() {
        if ($(this).text().trim() === currentType) {
          $(this).closest('li').addClass('sv_current_type');
        }
      });
    } else {
      // 无类型参数时，高亮第一个类型
      $('.sv_coll_filter_type li:first-child').addClass('sv_current_type');
    }
  }
  
  // 更新URL中的型号部分
  function updateUrlWithModel(model) {
    let currentUrl = window.location.href;
    
    // 移除page参数
    currentUrl = removePageParam(currentUrl);
    
    // 检查是否包含"all-iphone-cases"
    if (currentUrl.includes('all-iphone-cases')) {
      window.location.href = currentUrl.replace('all-iphone-cases', model);
      return;
    }
    
    // 常规处理
    const modelRegex = /collections\/(iphone-\d{1,2}(?:-pro)?(?:-plus)?(?:-max)?(?:-air)?-cases)/;
    
    if (currentUrl.match(modelRegex)) {
      window.location.href = currentUrl.replace(modelRegex, `collections/${model}`);
    } else {
      const baseUrl = currentUrl.split('?')[0];
      const queryString = currentUrl.split('?')[1] || '';
      window.location.href = `${baseUrl.replace('/collections/', `/collections/${model}`)}${queryString ? `?${queryString}` : ''}`;
    }
  }
  
  // 更新URL中的类型部分
  function updateUrlWithCaseType(caseType) {
    let currentUrl = window.location.href;
    
    // 移除page参数
    currentUrl = removePageParam(currentUrl);
    
    const encodedCaseType = encodeURIComponent(caseType).replace(/%20/g, '+');
    const typeRegex = /filter\.v\.option\.case\+type=([^&]+)/;
    
    if (currentUrl.match(typeRegex)) {
      window.location.href = currentUrl.replace(typeRegex, `filter.v.option.case+type=${encodedCaseType}`);
    } else {
      window.location.href = currentUrl + (currentUrl.includes('?') ? '&' : '?') + `filter.v.option.case+type=${encodedCaseType}`;
    }
  }
  
  // 移除URL中的page参数
  function removePageParam(url) {
    let newUrl = url.replace(/&page=\d+/, '');
    newUrl = newUrl.replace(/\?page=\d+/, '?');
    newUrl = newUrl.replace(/\?$/, '');
    newUrl = newUrl.replace(/&$/, '');
    newUrl = newUrl.replace(/&+/g, '&');
    return newUrl;
  }
  
  // 页面加载完成后初始化筛选器
  $(document).ready(function() {
    initCollectionFilter();
  });
})(jQuery);

// Disable image download
$(document).ready(function() {
    $(document).bind("contextmenu", function(e) {
        return false; // Prevents the default context menu from appearing
    });
});